import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHnFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53476)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 19.5402H0V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271L49.9999 19.5402Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 41.3795H0.862108C0.386034 41.3795 0 40.9934 0 40.5174V30.46H49.9999V40.5174C49.9999 40.9935 49.6139 41.3795 49.1378 41.3795Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9999 19.54H0V30.459H49.9999V19.54Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1246 23.5918L25.4331 24.5169L26.4082 24.5244C26.5345 24.5254 26.5867 24.6865 26.4853 24.7615L25.7008 25.3408L25.9949 26.2706C26.0329 26.391 25.896 26.4905 25.7932 26.4171L24.9999 25.8501L24.2066 26.417C24.1038 26.4904 23.9668 26.3909 24.0048 26.2705L24.299 25.3407L23.5145 24.7614C23.413 24.6864 23.4653 24.5253 23.5915 24.5243L24.5666 24.5168L24.8751 23.5917C24.9153 23.472 25.0846 23.472 25.1246 23.5918Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3186 26.0742L16.6271 26.9993L17.6022 27.0068C17.7284 27.0078 17.7807 27.1689 17.6792 27.2439L16.8948 27.8232L17.1889 28.753C17.227 28.8734 17.09 28.9729 16.9871 28.8996L16.1938 28.3326L15.4004 28.8996C15.2977 28.9729 15.1607 28.8734 15.1987 28.753L15.4928 27.8232L14.7083 27.2439C14.6069 27.1689 14.6591 27.0078 14.7854 27.0068L15.7605 26.9993L16.069 26.0742C16.1092 25.9544 16.2786 25.9544 16.3186 26.0742Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.3191 21.1088L16.6276 22.0339L17.6027 22.0414C17.7289 22.0424 17.7812 22.2035 17.6797 22.2785L16.8952 22.8578L17.1894 23.7876C17.2275 23.908 17.0905 24.0075 16.9876 23.9341L16.1943 23.3672L15.4009 23.9341C15.2982 24.0075 15.1612 23.908 15.1991 23.7876L15.4933 22.8578L14.7088 22.2785C14.6074 22.2035 14.6596 22.0424 14.7859 22.0414L15.761 22.0339L16.0695 21.1088C16.1097 20.9891 16.2791 20.9891 16.3191 21.1088Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.9305 26.0742L34.239 26.9993L35.2141 27.0068C35.3403 27.0078 35.3926 27.1689 35.2911 27.2439L34.5067 27.8232L34.8008 28.753C34.8389 28.8734 34.7019 28.9729 34.599 28.8996L33.8057 28.3326L33.0123 28.8996C32.9096 28.9729 32.7726 28.8734 32.8106 28.753L33.1047 27.8232L32.3202 27.2439C32.2186 27.1689 32.271 27.0078 32.3973 27.0068L33.3724 26.9993L33.6809 26.0742C33.7211 25.9544 33.8905 25.9544 33.9305 26.0742Z",
					fill: "#4173CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.9305 21.1088L34.239 22.0339L35.2141 22.0414C35.3403 22.0424 35.3926 22.2035 35.2911 22.2785L34.5067 22.8578L34.8008 23.7876C34.8389 23.908 34.7019 24.0075 34.599 23.9341L33.8057 23.3672L33.0123 23.9341C32.9096 24.0075 32.7726 23.908 32.8106 23.7876L33.1047 22.8578L32.3202 22.2785C32.2186 22.2035 32.271 22.0424 32.3973 22.0414L33.3724 22.0339L33.6809 21.1088C33.7211 20.9891 33.8905 20.9891 33.9305 21.1088Z",
					fill: "#4173CD"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53476",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHnFlag);
export { ForwardRef as ReactComponent };
